import React from "react";
import ReactDOM from "react-dom/client";

/* ===== External CSS ===== */
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/css/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";

/* ===== Bootstrap (CSS ONLY) ===== */
import "bootstrap/dist/css/bootstrap.min.css";

/* ===== PrimeReact ===== */
import 'nprogress/nprogress.css';
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../src/css/NPLoader.css"
import "../src/css/global.css"

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    //<React.StrictMode>
        <App />
    //</React.StrictMode>
);
